import styled from 'styled-components';
import { OptionWrapper } from '../Option/OptionStyles';
import { FieldingSequencePlayerWrapper } from './components/FieldingSequencePlayer/FieldingSequencePlayerStyles';

export const FieldingSequenceFlowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  margin-top: 4px;

  ${OptionWrapper} {
    &:hover {
      background-color: unset;
    }
  }
`;

export const FirstRow = styled.div`
  display: flex;
  margin-top: 13%;
  justify-content: space-around;
  margin-bottom: auto;
  ${FieldingSequencePlayerWrapper} {
    &.position-7 {
      margin-top: 7%;
    }
    &.position-9 {
      margin-top: 7%;
    }
  }
`;
export const SecondRow = styled.div`
  display: flex;
  margin-top: 3%;
  margin-left: 20%;
  margin-right: 20%;
  justify-content: space-around;
  margin-bottom: auto;
`;
export const ThirdRow = styled.div`
  margin-bottom: auto;
  display: flex;
  margin-left: 5%;
  margin-right: 5%;
  margin-bottom: 10%;
  justify-content: space-around;
`;
export const FourthRow = styled.div`
  display: flex;
  margin: 0% auto auto auto;
`;
